import React from "react";
import Skeleton from "react-loading-skeleton";
import { useMediaQuery } from "../../../../common/hooks/hooks";

const OrderPageSkeleton: React.FC = () => {
  // Use the hook to determine screen size.
  // 640px corresponds to the 'sm' breakpoint in variables.scss
  const isSmallScreen = useMediaQuery("(max-width: 640px)");

  // Dynamic width based on screen size
  const subtitleWidth = isSmallScreen ? 350 : 450;

  return (
    <div className="order-page-skeleton">
      {/* 1. Header (Icon + Title + Subtitle) */}
      <div className="order-page-skeleton__header">
        <div className="order-page-skeleton__icon">
          <Skeleton circle width={64} height={64} />
        </div>
        <Skeleton width={300} height={36} style={{ marginBottom: "0.5rem" }} />
        <Skeleton
          width={subtitleWidth}
          height={20}
          style={{ maxWidth: "100%" }}
        />
      </div>

      {/* 2. Summary Grid (4 items boxed) */}
      <div className="order-page-skeleton__summary">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="order-page-skeleton__summary-item">
            <Skeleton
              width={80}
              height={14}
              style={{ marginBottom: "0.5rem" }}
            />
            <Skeleton width={100} height={20} />
          </div>
        ))}
      </div>

      {/* 3. Items Summary List */}
      <div className="order-page-skeleton__items">
        <div className="order-page-skeleton__items-header">
          <Skeleton width={150} height={24} />
        </div>
        <div className="order-page-skeleton__items-list">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="order-page-skeleton__item">
              {/* Image */}
              <Skeleton
                width={60}
                height={60}
                style={{ marginRight: "1rem", flexShrink: 0 }}
              />
              {/* Details */}
              <div style={{ flexGrow: 1, paddingRight: "1rem" }}>
                <Skeleton width="60%" height={16} />
                <Skeleton
                  width="40%"
                  height={14}
                  style={{ marginTop: "0.5rem" }}
                />
              </div>
              {/* Price */}
              <Skeleton width={80} height={16} />
            </div>
          ))}
        </div>
      </div>

      {/* 4. Addresses Grid */}
      <div className="order-page-skeleton__addresses">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="order-page-skeleton__address-card">
            <Skeleton
              width={120}
              height={20}
              style={{ marginBottom: "1rem" }}
            />
            <Skeleton count={4} style={{ marginBottom: "0.25rem" }} />
          </div>
        ))}
      </div>

      {/* 5. Totals Box */}
      <div className="order-page-skeleton__totals">
        <Skeleton width={150} height={24} style={{ marginBottom: "1.5rem" }} />
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0.75rem",
            }}
          >
            <Skeleton width={100} />
            <Skeleton width={60} />
          </div>
        ))}
        <div
          style={{
            marginTop: "1rem",
            borderTop: "1px solid #eee",
            paddingTop: "1rem",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Skeleton width={80} height={24} />
            <Skeleton width={100} height={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPageSkeleton;
